import { defineComponent as _defineComponent } from 'vue'
import { defineAsyncComponent, ref } from 'vue'
import { useSelectsDynamicOptions } from '@/composables/useSelectsDynamicOptions'
import { clone } from 'ramda'
import { useSubmit } from '@/composables/useSubmit'
import useGlobal from '@/composables/useGlobal'
import useField from '@/composables/useField'
import { useModalOpener } from '@/composables/useModalOpener'
import { geoApi } from '@/services/geo.service'
import { appealsApi } from '@/services/appeals.service'
import { GtagEvents } from '@/const'

// import { feedbackCreate } from '@/modules/pages/queries'

enum SourceType {
  General = 'general',
  Documentation = 'documentation',
  Bonds = 'bonds',
  Vacancy = 'vacancy',
}


export default /*@__PURE__*/_defineComponent({
  __name: 'contact',
  props: {
    name: {},
    email: {},
    phone: {},
    sourceType: {},
    country: {},
    hideMessage: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const UiMessageModal = defineAsyncComponent(
  () => import('@/components/ui/modals/UiMessageModal.vue')
)
// const ControlDescriptor = defineAsyncComponent(() => import('@components/control/descriptor'))

const props = __props

const { $t } = useGlobal()
const userAgreement = window.user_agreement
const privacyPolicy = window.privacy_policy

const form = ref({
  name: props.name || '',
  email: props.email || '',
  phone: props.phone || '',
  country: props.country || null,
  sourceType: props.sourceType || SourceType.General,
  message: '',
  pageUrl: window.location.toString(),
})
const captchaRef = ref('')
const formRef = ref(null)

const isLoad = ref(false)

const {
  loading: countriesLoading,
  list: countriesList,
  load: countriesLoad,
  debounceSearch: countriesSearch,
  get: countriesGet,
} = useSelectsDynamicOptions(geoApi.countriesList)
countriesGet()

const keyForReloadPhone = ref(1)
const currentCountryCode = window.country_code

const validateForm = async (f, action, setFieldError) => {
  const { valid } = await f()
  if (valid) {
    try {
      await action()
    } catch (e) {
      console.warn(e)
    }
  }
}

const getCaptcha = async () => {
  await captchaRef.value.execute()
}

const saveCaptcha = async (val) => {
  form.value.recaptcha = val
  await request(form.value, formRef.value)
}

const request = (sendData, control) => {
  isLoad.value = true
  return useSubmit(send(sendData), control)
}

const send = async (sendData) => {
  const transformed = clone(sendData)
  transformed.country = sendData.country?.uuid
  try {
    const {
      data: {
        messages: [message],
      },
    } = await appealsApi.connectWithUs.execute({}, transformed)
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: GtagEvents.feedback_form_submission,
      email: form.value.email,
    })
    isLoad.value = false
    formRef.value.resetForm({
      values: {
        name: props.name || '',
        email: props.email || '',
        phone: props.phone || '',
        country: props.country || null,
        sourceType: props.sourceType || SourceType.General,
        message: '',
        pageUrl: window.location.toString(),
      },
    })
    keyForReloadPhone.value += keyForReloadPhone.value
    form.value.phone = props.phone || ''
    keyForReloadPhone.value += keyForReloadPhone.value
    // Object.keys(form.value).forEach(k => {
    //   form.value[k] = ''
    // })
    const { open } = useModalOpener({
      name: 'UiMessageModal',
      component: UiMessageModal,
      message,
    })
    if (captchaRef.value) {
      captchaRef.value.reset()
    }
    open()
  } catch (e) {
    isLoad.value = false
    captchaRef.value.reset()
    throw e
  }
}

const __returned__ = { UiMessageModal, SourceType, props, $t, userAgreement, privacyPolicy, form, captchaRef, formRef, isLoad, countriesLoading, countriesList, countriesLoad, countriesSearch, countriesGet, keyForReloadPhone, currentCountryCode, validateForm, getCaptcha, saveCaptcha, request, send, defineAsyncComponent, ref, get useSelectsDynamicOptions() { return useSelectsDynamicOptions }, get clone() { return clone }, get useSubmit() { return useSubmit }, get useGlobal() { return useGlobal }, get useField() { return useField }, get useModalOpener() { return useModalOpener }, get geoApi() { return geoApi }, get appealsApi() { return appealsApi }, get GtagEvents() { return GtagEvents } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})